import { InitializeValidateDepartmentsRequestSchema, InitializeValidateDepartmentsResponseSchema } from './initialize-validate-departments.schema';
/**
 * Initialize Validate Departments Contract
 * POST /api/v2/initialize/departments/validate
 * Dry-run validation with per-row issues; never writes. Resolves parent
 * abbreviations and manager emails, checks for circular dependencies and
 * determines the creation order.
 */ export const InitializeValidateDepartmentsContract = {
    method: 'POST',
    path: '/api/v2/initialize/departments/validate',
    description: 'Validate departments before bulk creation with dependency resolution',
    requestSchema: InitializeValidateDepartmentsRequestSchema,
    responseSchema: InitializeValidateDepartmentsResponseSchema,
    statusCodes: {
        success: 200,
        errors: {
            400: 'Invalid request body or validation error',
            401: 'Unauthorized - user not authenticated',
            403: 'Forbidden - insufficient permissions'
        }
    }
};

//# sourceMappingURL=initialize-validate-departments.contract.js.map